import React from 'react';
import { useTranslation } from 'react-i18next';

// @mui
import { Tooltip, IconButton } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import { useThemeMode } from 'src/theme';

import Iconify from 'src/components/iconify';

export function ThemeModeToggle() {
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();
  const { themeMode, toggleThemeMode } = useThemeMode();

  const isDark = themeMode === 'dark';

  return (
    <Tooltip
      title={
        isDark
          ? t('navbar.lightMode') || 'Light Mode'
          : t('navbar.darkMode') || 'Dark Mode'
      }
    >
      <IconButton
        onClick={toggleThemeMode}
        sx={{
          padding: 0,
          width: isSmallScreen ? 35 : 44,
          height: isSmallScreen ? 35 : 44,
          transition: 'transform 0.3s ease-in-out',
          '&:hover': {
            transform: 'rotate(15deg) scale(1.05)',
            bgcolor: 'action.hover',
          },
          '&:active': {
            transform: 'scale(0.95)',
          },
        }}
      >
        <Iconify
          icon={isDark ? 'solar:sun-2-bold-duotone' : 'solar:moon-bold-duotone'}
          width={isSmallScreen ? 23 : 28}
          height={isSmallScreen ? 23 : 28}
          sx={{
            color: isDark ? 'warning.main' : 'text.secondary',
            transition: 'color 0.3s ease',
          }}
        />
      </IconButton>
    </Tooltip>
  );
}

export default ThemeModeToggle;
